import Reveal from "@/components/Reveal";
import { CONTACT } from "@/data/products";

const SECTIONS = [
  {
    title: "1. General Information",
    body: "This website is an informational site for Raj Kumari Kirana Store, a neighbourhood grocery and retail shop. It is intended to help customers learn about our products, store hours and contact options.",
  },
  {
    title: "2. No Online Sales",
    body: "This website does not process orders or payments. Product listings, images and prices shown are indicative only. Final availability and pricing are confirmed in store, over the phone or on WhatsApp at the time of purchase.",
  },
  {
    title: "3. Prices & Availability",
    body: "Prices of grocery items change with market conditions. While we try to keep the website current, actual prices and stock may differ on any given day. We reserve the right to update products and prices without prior notice.",
  },
  {
    title: "4. Product Images",
    body: "Images on this site are representative and used for illustration. Actual packaging, brand and weight may vary from what is shown.",
  },
  {
    title: "5. External Services",
    body: "Links to WhatsApp, phone and email are provided for your convenience. We are not responsible for the availability or policies of those external services.",
  },
  {
    title: "6. Limitation of Liability",
    body: "Raj Kumari Kirana Store is not liable for any loss arising from reliance on information presented on this website. For health, allergy or dietary concerns, always check the product label in store before purchase.",
  },
  {
    title: "7. Contact",
    body: `Questions about this disclaimer? Write to ${CONTACT.email} or call ${CONTACT.phone}.`,
  },
];

const Disclaimer = () => (
  <main className="pt-32 pb-24 px-6 md:px-10 min-h-screen">
    <div className="max-w-3xl mx-auto">
      <Reveal>
        <p className="uppercase text-xs sm:text-sm font-semibold tracking-[0.2em] text-spice">Legal</p>
        <h1 className="font-serif font-bold tracking-tight text-ink text-4xl sm:text-5xl mt-4">Disclaimer</h1>
        <p className="text-mut text-sm mt-4">Effective July 2026 · Raj Kumari Kirana Store</p>
      </Reveal>
      <div className="mt-12 flex flex-col gap-10">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.04}>
            <h2 className="font-serif font-semibold text-coffee text-xl md:text-2xl">{s.title}</h2>
            <p className="text-bark leading-relaxed mt-3 text-sm md:text-base">{s.body}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </main>
);

export default Disclaimer;
